import React from "react";
import { OKBig } from "../../../../../icon/Icon";
import { SubmitModalButton } from "../../../../../components/ui/Button";
import { Title } from "../../../../../components/Font";
import { Popup } from "../../../../../ui/Modal/Popup";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

interface IPhoneConfirmProps {
  onClose(): void;
}

export const PhoneConfirmSuccess = ({ onClose }: IPhoneConfirmProps) => {
  const { t } = useTranslation();
  return (
    <Popup
      className="radius"
      style={{
        padding: 0,
        gap: 0,
        width: 410,
        height: "fit-content",
      }}
      title={<OKBig />}
      opened={true}
      onClose={onClose}
    >
      <PopupBody>
        <Title style={{ margin: "0 0 16px 0" }}>
          {t("passport.registrationForm.phoneConfirm.success")}
        </Title>
        <SubmitModalButton onClick={onClose}>
          {t("passport.registrationForm.phoneConfirm.thanks")}
        </SubmitModalButton>
      </PopupBody>
    </Popup>
  );
};

const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 24px 24px;
`;
